export default "__VITE_ASSET__CIRZS_cv__"